import Checkbox, { INDETERMINATE } from 'lib/Checkbox';
import { Option } from 'utils/multiDimensionalListUtils';
import { SelectionIndicator } from './SelectionIndicator';

interface ExpandableDropdownOptionProps {
  option: Option;
  isSelectable?: boolean;
  checkboxIsSelected: boolean | typeof INDETERMINATE;
  itemSelectionStatus: string;
  onChange: (checked: boolean) => void;
}

export const ExpandableDropdownOption = ({
  option,
  isSelectable,
  checkboxIsSelected,
  itemSelectionStatus,
  onChange,
}: ExpandableDropdownOptionProps): React.ReactElement => {
  if (isSelectable) {
    return (
      <div className="w-max px-1">
        <Checkbox
          value={option.code ?? undefined}
          label={<p className="text-neutral-950-opacity-80 body-base inline break-words ml-2">{option.name}</p>}
          isSelected={checkboxIsSelected}
          name={`group-${option.code}`}
          onChange={onChange}
        />
      </div>
    );
  }

  return (
    <div className="flex items-center">
      <SelectionIndicator status={itemSelectionStatus} />
      <p>{option.name}</p>
    </div>
  );
};
